var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurfaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 2C0.9 1.39249 1.39249 0.9 2 0.9H9C9.60751 0.9 10.1 1.39249 10.1 2V8C10.1 8.60751 9.60751 9.1 9 9.1H2C1.39249 9.1 0.9 8.60751 0.9 8V2ZM13.9 2C13.9 1.39249 14.3925 0.9 15 0.9H23C23.6075 0.9 24.1 1.39249 24.1 2V11C24.1 11.6075 23.6075 12.1 23 12.1H15C14.3925 12.1 13.9 11.6075 13.9 11V2ZM0.9 14C0.9 13.3925 1.39249 12.9 2 12.9H10C10.6075 12.9 11.1 13.3925 11.1 14V23C11.1 23.6075 10.6075 24.1 10 24.1H2C1.39249 24.1 0.9 23.6075 0.9 23V14ZM14.9 17C14.9 16.3925 15.3925 15.9 16 15.9H23C23.6075 15.9 24.1 16.3925 24.1 17V23C24.1 23.6075 23.6075 24.1 23 24.1H16C15.3925 24.1 14.9 23.6075 14.9 23V17Z",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfaceIcon);
export default __webpack_public_path__ + "static/media/SurfaceIcon.06fa3ba22fe3a406698e54be6896075b.svg";
export { ForwardRef as ReactComponent };